import { Component, ElementRef, Inject, NgZone, PLATFORM_ID, TransferState } from '@angular/core';

import {
  DxDrawerComponent,
  DxDrawerModule,
  DxTemplateHost,
  DxTemplateModule,
  IterableDifferHelper,
  NestedOptionHost,
  WatcherHelper,
} from 'devextreme-angular';
import { AbcComponentService, AbcContainerService } from 'libs/abc/ui-components/src';
import { IDrawer } from './abcDrawer';

@Component({
    selector: 'abc-drawer',
    imports: [DxTemplateModule, DxDrawerModule],
    template: `
    <ng-content *dxTemplate="let data of 'panel'" select="[content=abcDrawerContainer]"> </ng-content>
    <ng-content select="[content=abcDrawerContent]"> </ng-content>
  `,
    providers: [
        AbcComponentService,
        AbcContainerService,
        DxTemplateHost,
        WatcherHelper,
        IterableDifferHelper,
        NestedOptionHost,
    ]
})
export class _AbcDrawerComponent extends DxDrawerComponent {
  constructor(
    elementRef: ElementRef,
    ngZone: NgZone,
    templateHost: DxTemplateHost,
    _watcherHelp: WatcherHelper,
    _idh: IterableDifferHelper,
    optionHost: NestedOptionHost,
    transferState: TransferState,
    @Inject(PLATFORM_ID) platformId: any
  ) {
    super(elementRef, ngZone, templateHost, _watcherHelp, optionHost, transferState, platformId);
  }
  private eventListener = [];
  public htmlAttributes: IDrawer;
  addEventListener(
    type: string,
    listener: EventListenerOrEventListenerObject,
    options?: boolean | AddEventListenerOptions
  ): void {
    this.eventListener.push({ type, listener });
  }
}
